


let base_url: string = 'https://imake-app.com';

export const environment = {
   production: false,
   ApiEndPoint2: `${base_url}:1116/api`,
   site_name: 'i-seven'
};

